var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.92 7.784C2.11 7.191 1.46 6.506 1.098 6c.363-.506 1.014-1.19 1.824-1.784C3.878 3.514 4.977 3 6 3s2.122.514 3.08 1.216c.81.593 1.46 1.278 1.823 1.784-.363.506-1.014 1.19-1.824 1.784C8.122 8.486 7.023 9 6 9s-2.122-.514-3.08-1.216M6 2c-1.33 0-2.638.653-3.67 1.41C1.293 4.167.454 5.09.068 5.745a.5.5 0 0 0 0 .508c.386.655 1.225 1.578 2.26 2.337C3.362 9.347 4.67 10 6 10s2.638-.653 3.67-1.41c1.036-.758 1.875-1.68 2.261-2.336a.5.5 0 0 0 0-.508c-.386-.655-1.225-1.578-2.26-2.337C8.638 2.653 7.33 2 6 2m1 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0m1 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
    clipRule: "evenodd"
  })));
});
const SvgVisibilityOnsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisibilityOnsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjkyMDUzIDcuNzg0MTlDMi4xMTA5MiA3LjE5MDkzIDEuNDU5OTQgNi41MDYwNCAxLjA5NzQ1IDZDMS40NTk5NCA1LjQ5Mzk2IDIuMTEwOTIgNC44MDkwNyAyLjkyMDUzIDQuMjE1ODFDMy44NzgxMyAzLjUxNDEzIDQuOTc3MDkgMyA2IDNDNy4wMjI5MSAzIDguMTIxODcgMy41MTQxMyA5LjA3OTQ3IDQuMjE1ODFDOS44ODkwOCA0LjgwOTA3IDEwLjU0MDEgNS40OTM5NiAxMC45MDI2IDZDMTAuNTQwMSA2LjUwNjA0IDkuODg5MDggNy4xOTA5MyA5LjA3OTQ3IDcuNzg0MTlDOC4xMjE4NyA4LjQ4NTg3IDcuMDIyOTEgOSA2IDlDNC45NzcwOSA5IDMuODc4MTMgOC40ODU4NyAyLjkyMDUzIDcuNzg0MTlaTTYgMkM0LjY2OTk2IDIgMy4zNjIwNyAyLjY1MjU0IDIuMzI5NDcgMy40MDkxOUMxLjI5NDEzIDQuMTY3ODQgMC40NTQ3OTEgNS4wOTA3IDAuMDY5MDMyOSA1Ljc0NjQ5Qy0wLjAyMzAxMSA1LjkwMjk2IC0wLjAyMzAxMSA2LjA5NzA0IDAuMDY5MDMyOSA2LjI1MzUxQzAuNDU0NzkxIDYuOTA5MyAxLjI5NDEzIDcuODMyMTYgMi4zMjk0NyA4LjU5MDgxQzMuMzYyMDcgOS4zNDc0NiA0LjY2OTk2IDEwIDYgMTBDNy4zMzAwNCAxMCA4LjYzNzkzIDkuMzQ3NDYgOS42NzA1MyA4LjU5MDgxQzEwLjcwNTkgNy44MzIxNiAxMS41NDUyIDYuOTA5MyAxMS45MzEgNi4yNTM1MUMxMi4wMjMgNi4wOTcwNCAxMi4wMjMgNS45MDI5NiAxMS45MzEgNS43NDY0OUMxMS41NDUyIDUuMDkwNyAxMC43MDU5IDQuMTY3ODQgOS42NzA1MyAzLjQwOTE5QzguNjM3OTMgMi42NTI1NCA3LjMzMDA0IDIgNiAyWk03IDZDNyA2LjU1MjI4IDYuNTUyMjggNyA2IDdDNS40NDc3MiA3IDUgNi41NTIyOCA1IDZDNSA1LjQ0NzcyIDUuNDQ3NzIgNSA2IDVDNi41NTIyOCA1IDcgNS40NDc3MiA3IDZaTTggNkM4IDcuMTA0NTcgNy4xMDQ1NyA4IDYgOEM0Ljg5NTQzIDggNCA3LjEwNDU3IDQgNkM0IDQuODk1NDMgNC44OTU0MyA0IDYgNEM3LjEwNDU3IDQgOCA0Ljg5NTQzIDggNloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";